<div *ngIf="formGroup" [formGroup]="formGroup">
    <u2b-message type="info">
        <ng-container *ngIf="owner; else noOwner">
            {{ 'workflows.shared.ownerLabel' | translate }} <strong>{{owner.fullName}}</strong>
        </ng-container>
        <ng-template #noOwner>
            {{('workflows.screens.winterStorageInvoicePositions.assetNoOwner' | translate : {asset: (winterStorageAssignment.boat ? ('boats.singular' | translate) : 'Asset')})}}
        </ng-template>
    </u2b-message>

    <mat-divider class="special-divider"></mat-divider>

    <div class="mb-24">
        <mat-checkbox formControlName="deviatingInvoiceRecipient">{{ 'workflows.screens.winterStorageInvoicePositions.deviatingInvoiceRecipient' | translate }}</mat-checkbox>
    </div>

    <ng-container *ngIf="formGroup.get('deviatingInvoiceRecipient').value">
        <div>
            <mat-radio-group class="radio-group-inline" formControlName="invoiceRecipientType">
                <mat-radio-button [value]="'person'">{{ 'person.singular' | translate }}</mat-radio-button>
                <mat-radio-button [value]="'company'">{{ 'company.singular' | translate }}</mat-radio-button>
            </mat-radio-group>
        </div>

        <ng-container *ngIf="formGroup.get('invoiceRecipientType').value === 'person'">
            <form-widget-person [optionalFields]="true"></form-widget-person>
        </ng-container>

        <ng-container *ngIf="formGroup.get('invoiceRecipientType').value === 'company'">
            <form-widget-company [optionalFields]="true"></form-widget-company>
        </ng-container>
    </ng-container>

    <mat-divider class="special-divider"></mat-divider>

    <form-widget-invoice [parentFormGroup]="formGroup"
                         [givenStartDate]="winterStorageAssignment?.from"
                         [givenEndDate]="winterStorageAssignment?.to"
                         [givenCostCenter]="winterStorageAssignment?.winterStorage?.costCenter"></form-widget-invoice>

    <mat-divider class="special-divider"></mat-divider>

    <ng-container *ngIf="subscription">
        <form-widget-subscription-period [parentFormGroup]="formGroup"></form-widget-subscription-period>
        <mat-divider class="special-divider"></mat-divider>
    </ng-container>

    <ng-container *ngIf="(formGroup.dirty && formGroup.invalid) || positions.length === 0">
        <u2b-message type="warning" customClass="mt-24">
            {{ 'workflows.shared.formInvalidHint' | translate }}
        </u2b-message>
    </ng-container>

    <ng-container *ngIf="formGroup.dirty && formGroup.valid && positions.length > 0">
        <u2b-message type="success" customClass="mt-24">
            <header>{{ 'workflows.shared.formCompleteTitle' | translate }}</header>
            {{ 'workflows.shared.formCompleteSaveHint' | translate }}
        </u2b-message>
    </ng-container>
</div>
